import React from 'react';

const DashboardSummary = ({ children }) => (
    <div className="dashboard-summary">
        {children}
    </div>
);

export default DashboardSummary;
